const PrivacyPolicy = () => {
    return (
        <div className="text-center pt-3 mt-3">
            <small className="text-muted">
                <a className="text-secondary" href="https://app.raterspot.com/privacy.html" rel="noreferrer" target="_blank">Terms of Services</a> and <a href="https://app.raterspot.com/privacy.html" className="text-secondary" rel="noreferrer" target="_blank">Privacy Policy</a>
            </small>
        </div>
    );
};

export default PrivacyPolicy;